const logoData = [
    {
        filename: "react-logo.png",
        alt: "React",
    },
    {
        filename: "nextjs-logo.svg",
        alt: "Next.js",
    },
    {
        filename: "typescript-logo.svg",
        alt: "TypeScript",
    },
    {
        filename: "node-logo.png",
        alt: "Node.js",
    },
    {
        filename: "python-logo.svg",
        alt: "Python",
    },
    {
        filename: "postgresql-logo.svg",
        alt: "PostgreSQL",
    },
    {
        filename: "mongodb-logo.svg",
        alt: "MongoDB",
    },
    {
        filename: "redis-logo.svg",
        alt: "Redis",
    },
    {
        filename: "ai-logo.svg",
        alt: "LLMs and AI",
    },
]

export default logoData